import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: ()=>import('./views/Home.vue')
    },
    {
      path:'/news/:id',
      name:'news',
      component:()=>import('./views/Article.vue')
    },
    {
      path: '/:page',
      name: 'page',
      component: () => import('./views/Page.vue')
    }
  ]
})
